import React, { useState, useEffect, useContext } from "react";
import { getServers } from "./services/ScheduleService";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Schedule from "./pages/Schedule";
import Results from "./pages/Results";
import Stats from "./pages/Stats";
import Standings from "./pages/Standings";
import MatchDetail from "./pages/MatchDetail";

export const ServerContext = React.createContext({ selectedServerIds: [], setSelectedServerIds: () => {} });

function AppContent() {
    const navigate = useNavigate();
    const location = useLocation();
    const [servers, setServers] = useState([]);
    const [selectedServerIds, setSelectedServerIds] = useState([]);

    const activePage = location.pathname.replace("/", "") || "live";
    const handleNavigate = (page) => {
        navigate(`/${page}`);
    };

    useEffect(() => {
        getServers().then((data) => {
            if (data && data.servers) {
                setServers(data.servers);
            }
        }).catch((err) => console.log("Servers fetch error:", err));
    }, []);

    const handleServerToggle = (serverId) => {
        setSelectedServerIds(prev =>
            prev.includes(serverId)
                ? prev.filter(id => id !== serverId)
                : [...prev, serverId]
        );
    };

    const handleSelectAll = () => {
        setSelectedServerIds([]);
    };

    const showServerFilter = ["/live", "/results", "/schedule"].includes(location.pathname);

    useEffect(() => {
        const rule = process.env.REACT_APP_RULE || "1";
        document.documentElement.className = `theme-rule-${rule}`;
    }, []);

    return (
        <ServerContext.Provider value={{ selectedServerIds, setSelectedServerIds }}>
            <div>
                <div className="hex-bg"></div>
                <Navbar activePage={activePage} onNavigate={handleNavigate} />
                {showServerFilter && servers.length > 0 && (
                    <div className="server-filter-bar">
                        <span className="server-filter-label">
                            <span className="ping-dot" style={{ background: "var(--pink)" }}></span>
                            SELECT SERVER →
                        </span>
                        <label className={`server-chip ${selectedServerIds.length === 0 ? "active" : ""}`}>
                            <input type="checkbox" checked={selectedServerIds.length === 0} onChange={handleSelectAll} />
                            All
                        </label>
                        {servers.map(server => (
                            <label key={server.serverId} className={`server-chip ${selectedServerIds.includes(server.serverId) ? "active" : ""}`}>
                                <input
                                    type="checkbox"
                                    checked={selectedServerIds.includes(server.serverId)}
                                    onChange={() => handleServerToggle(server.serverId)}
                                />
                                {server.name}
                            </label>
                        ))}
                    </div>
                )}
                <Routes>
                    <Route path="/" element={<Navigate to="/live" />} />
                    <Route path="/live" element={<Home />} />
                    <Route path="/results" element={<Results />} />
                    <Route path="/schedule" element={<Schedule />} />
                    <Route path="/stats" element={<Stats />} />
                    <Route path="/standings" element={<Standings />} />
                    <Route path="*" element={<Navigate to="/" />} />
                    <Route path="/match/:matchId" element={<MatchDetail />} />
                </Routes>
            </div>
        </ServerContext.Provider>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent />
        </BrowserRouter>
    );
}

export default App;

//////6264